/* eslint-disable no-console */

// Form submit
// Determines should the user be asked to give marketing consent
// ----------------------------------------------------------------

import $ from 'jquery';

import { validationForm } from '../donation-form/validation-form';
import { inputValidationOnClick } from '../donation-form/input-validation-on-click';

const petitionFormElement = $('.petition-form');
const petitionMarketingModal = $('.js-petition-modal');
const petitionMarketingModalInputs = $('.js-petition-modal input');
const petitionMarketingModalCloseButton = $('.js-petition-modal .modal-close');
const petitionMarketingModalSubmitButton = $('#buttonMarketingSubmitAppealModal');
const petitionNewsletterInput = $('.petition-form input[name=newsletter]');
const petitionEmailInput = $('#petition-email');
const petitionOver18Input = $('#over18Years');
const petitionMessageInput = $('.petition-message');
const petitionMessageLengthOutput = $('.petition-message-counter__count');

const marketingNoAppealModal = $('.js-marketingNoAppealModalShowMore');
const marketingNoText = $('.js-petition-marketing-no-text');

// hijack the form submit event, if needed
const petitionMarketingModalSubmitHandler = async () => {
    const hasEmail = $(petitionEmailInput).is(':valid');
    const firstName = $("#petition-first-name").val();
    const fieldset = $(petitionFormElement).find('fieldset');

    inputValidationOnClick(fieldset);
    const formIsValid = validationForm(petitionFormElement);

    const text = $('.js-petition-modal-title').text();
    $('.js-petition-modal-title').text(text.replace('%etunimi%', firstName));

    if (hasEmail && formIsValid) {

        const data = {
            email: $(petitionEmailInput).val(),
        }

        const options = {
            data: data,
            async: true,
            method: 'POST',
            url: '/wp-json/amnesty-fi/v1/check-email-opt-out'
        };

        $.ajax(options).done((response) => {

            // ----------------------------------------------------------------
            // ----------------------------------------------------------------
            // The original thing before things got updated.
            // if (response && response['userOptOutStatus']) {
            //     // show modal when needed
            //     initPetitionMarketingModal();
            // } else {
            //     // else submit form
            //     // @todo: add visible loading state for user
            //     $(petitionFormElement).trigger('submit');
            // }
            // ----------------------------------------------------------------
            // ----------------------------------------------------------------

            if (
              response['userAlreadyExistsStatus'] &&
              response['userAlreadyExistsStatus'] !== 'true'
            ) {
                initPetitionMarketingModal();
                return;
            }

            if (
              response['userOptOutStatus'] &&
              response['userOptOutStatus'] === 'true'
            ) {
                initPetitionMarketingModal();
                return;
            }

            else {
              $(petitionFormElement).trigger('submit');
            }

            // Submit form after determining the things above.
            // form.off('submit').trigger('submit');
        });
    }
}

marketingNoAppealModal.on('click', function () {
    $(this).parent().find('.js-marketingAppealModalSubmitYes').removeClass('u-bg-yellow')
    $(this).addClass('u-bg-yellow')
    marketingNoText.removeClass('u-hidden');
})

const initPetitionMarketingModal = () => {
    // @todo: build a focus trap
    $(petitionMarketingModal).addClass('is-open').prop('aria-hidden', false).focus();
    $(petitionMarketingModalCloseButton).prop('disabled', false);
    $(petitionMarketingModalInputs).prop('disabled', false);
    petitionMarketingModalSubmitButton.prop('disabled', false);
}

const closePetitionMarketingModal = () => {
    $(petitionMarketingModal).removeClass('is-open').prop('aria-hidden', true);
    $(petitionMarketingModalCloseButton).prop('disabled', true);
    $(petitionMarketingModalInputs).prop('disabled', true);
    petitionMarketingModalSubmitButton.prop('disabled', true);
}

const updateCombinedFormData = (marketing = '') => {
    let checkedState = false;
    if (marketing === 'yes') {
      checkedState = true;
    }

    const isOver18 = $(petitionOver18Input).is(':checked') ? 'yes' : 'no';
    const separator = marketing ? '-' : '';

    petitionNewsletterInput.prop('checked', checkedState);
    petitionNewsletterInput.val(`${isOver18}${separator}${marketing}`);
}

updateCombinedFormData();

$(petitionMarketingModalCloseButton).on ('click', () => {
    closePetitionMarketingModal();
});

$(petitionOver18Input).on('input', updateCombinedFormData);


$('.js-marketingAppealModalSubmitYes').on('click', () => {
    const marketing = 'yes';
    updateCombinedFormData(marketing);
    $(petitionFormElement).trigger('submit');
})
$('.js-marketingAppealModalSubmitNo').on('click', () => {
    $('.js-marketingAppealModalSubmitYes').removeClass('u-bg-yellow')
    const marketing = 'no'
    updateCombinedFormData(marketing);
    $(petitionFormElement).trigger('submit');
})


$(petitionMarketingModalSubmitButton).on ('click', () => {
    if ($(petitionMarketingModal).find('[name=petitionmarketing]:checked').length > 0) {
        petitionMarketingModalSubmitButton.prop('disabled', true);
        closePetitionMarketingModal();
        // remove the form submit hijacking & submit
        $(petitionFormElement).off('click', 'button[type=submit]', petitionMarketingModalSubmitHandler);
        // @todo: add visible loading state for user
        $(petitionFormElement).trigger('submit');
    } else {
        // invalidate form?
    }
});

const updatePetitionMessageLengthOutput = () => {
    if (petitionMessageInput && petitionMessageInput.length) {
        const petitionMessageLength = $(petitionMessageInput).val().length;
        $(petitionMessageLengthOutput).html(petitionMessageLength);
    }
}

updatePetitionMessageLengthOutput();

$(petitionMessageInput).on('input', updatePetitionMessageLengthOutput);

window.onSubmitPetitionForm = (() => {
  petitionMarketingModalSubmitHandler();
});
